// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"604":"company","873":"company-list"}[chunkId] || chunkId) + "." + {"604":"2eda5f6bfff72c596d05","614":"1d2bcf4835c135cf62a9","764":"c96ab39bab3bcc2b6d7e","873":"2060d5e1b72b93f10d55","924":"066d695631129f5f2429"}[chunkId] + ".js";
};